// @flow
export const ApiStatusEnum = Object.freeze({
  Loading: 'loading',
  Success: 'success',
  Error: 'error',
});

export type ApiStatusEnumType = $Values<typeof ApiStatusEnum>;
